<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <router-link
        :to="{ name: 'side-menu-dashboard-overview-1' }"
        class="text-lg font-medium mr-auto flex items-center"
      >
        <ChevronLeftIcon />Dashboard (จังหวัด)
      </router-link>
    </div>
    <!-- BEGIN: Data List -->
    <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
      <table class="table table-report -mt-2">
        <thead>
          <tr>
            <th class="text-center whitespace-nowrap">#</th>
            <th class="whitespace-nowrap">จังหวัด</th>
            <th class="text-center whitespace-nowrap">จำนวน</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="province in provinces.value"
            :key="province"
            class="intro-x"
          >
            <td class="w-10">
              <div class="text-center">
                {{ province.no }}
              </div>
            </td>
            <td>
              <div class="flex">
                {{ province.provinceName }}
              </div>
            </td>
            <td>
              <div class="text-center">
                <b>{{ province.numberOfUser }}</b>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- END: Data List -->
  </div>
</template>

<script>
import { defineComponent, reactive, onMounted } from "vue";
import * as dashboardService from "/src/services/dashboard";

export default defineComponent({
  setup() {
    const provinces = reactive([]);

    const getProvinceList = () => {
      dashboardService
        .getDashboadProvinces()
        .then(res => {
          console.log(res);
          if (res.data.data) {
            provinces.value = res.data.data.map((x, index) => {
              x.no = index + 1;
              return x;
            });
          } else {
            provinces.value = [];
          }
        })
        .catch(err => {
          console.log(err);
        });
    };

    onMounted(() => {
      getProvinceList();
    });

    return {
      provinces,
      getProvinceList
    };
  }
});
</script>
